if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 80));
      this.initFadeMode();
      this.initLiveThumbnailSync();
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }
        initLiveThumbnailSync() {
      let attempts = 0;
      const connect = () => {
        const viewerSlider = this.elements.viewer?.slider;
        const thumbnailsSlider = this.elements.thumbnails?.slider;
        if (!viewerSlider || !thumbnailsSlider) {
          attempts += 1;
          if (attempts < 60) {
            requestAnimationFrame(connect);
          }
          return;
        }
        this.viewerSlider = viewerSlider;
        this.thumbnailsSlider = thumbnailsSlider;
        this.boundSyncThumbnails =
          this.syncThumbnailsWhileScrolling.bind(this);
        viewerSlider.addEventListener(
          'scroll',
          this.boundSyncThumbnails,
          { passive: true }
        );
        window.addEventListener(
          'resize',
          this.boundSyncThumbnails,
          { passive: true }
        );
        this.mql.addEventListener?.(
          'change',
          this.boundSyncThumbnails
        );
        this.syncThumbnailsWhileScrolling();
      };
      connect();
    }
    disconnectedCallback() {
      if (!this.boundSyncThumbnails) return;
      this.viewerSlider?.removeEventListener(
        'scroll',
        this.boundSyncThumbnails
      );
      window.removeEventListener(
        'resize',
        this.boundSyncThumbnails
      );
      this.mql.removeEventListener?.(
        'change',
        this.boundSyncThumbnails
      );
    }
    syncThumbnailsWhileScrolling() {
      if (this.mql.matches || this.elements.thumbnails?.vertical) {
        return;
      }
      const viewerSlider =
        this.viewerSlider || this.elements.viewer?.slider;
      const thumbnailsSlider =
        this.thumbnailsSlider || this.elements.thumbnails?.slider;
      if (!viewerSlider || !thumbnailsSlider) return;
      const slides = Array.from(
        viewerSlider.querySelectorAll(
          '.product__media-item:not(.hidden)'
        )
      );
      const thumbnails = Array.from(
        thumbnailsSlider.querySelectorAll(
          '.thumbnail-list__item:not(.hidden)'
        )
      );
      if (slides.length < 2 || thumbnails.length < 2) return;
      const viewerMaxScroll = Math.max(
        0,
        viewerSlider.scrollWidth - viewerSlider.clientWidth
      );
      if (!viewerMaxScroll) return;
      const progress = Math.min(
        1,
        Math.max(0, viewerSlider.scrollLeft / viewerMaxScroll)
      );
      const fractionalIndex =
        progress * (slides.length - 1);
      const nearestIndex = Math.min(
        thumbnails.length - 1,
        Math.max(0, Math.round(fractionalIndex))
      );
      if (this.liveThumbnailIndex !== nearestIndex) {
        this.liveThumbnailIndex = nearestIndex;
        this.markActiveThumbnail(thumbnails[nearestIndex]);
      }
      const thumbnailsMaxScroll = Math.max(
        0,
        thumbnailsSlider.scrollWidth - thumbnailsSlider.clientWidth
      );
      if (!thumbnailsMaxScroll) return;
      const thumbnailStep =
        Math.abs(
          thumbnails[1].offsetLeft -
          thumbnails[0].offsetLeft
        ) || thumbnails[0].offsetWidth;
      if (!thumbnailStep) return;
      const visibleThumbnailCount = Math.max(
        1,
        Math.round(
          thumbnailsSlider.clientWidth / thumbnailStep
        )
      );
      const centerOffset =
        Math.floor(visibleThumbnailCount / 2);
      const targetScroll = Math.min(
        thumbnailsMaxScroll,
        Math.max(
          0,
          (fractionalIndex - centerOffset) * thumbnailStep
        )
      );
      thumbnailsSlider.scrollLeft = targetScroll;
    }
    markActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails
        .querySelectorAll('button[aria-current]')
        .forEach((element) => {
          element.removeAttribute('aria-current');
        });
      thumbnail
        .querySelector('button')
        ?.setAttribute('aria-current', 'true');
    }
    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        }
      });
      this.playActiveMedia(activeMedia);
      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }
      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }
    setActiveThumbnail(thumbnail) {
  if (!this.elements.thumbnails || !thumbnail) return;
  this.markActiveThumbnail(thumbnail);
  if (this.mql.matches || this.elements.thumbnails.vertical) {
    if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;
    if (this.elements.thumbnails.vertical) {
      this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
    } else {
      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }
  }
}
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }
    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
    initFadeMode() {
  const tryInit = () => {
    const viewerSlider = this.elements.viewer?.slider;
    if (!viewerSlider) {
      requestAnimationFrame(tryInit);
      return;
    }
    viewerSlider.style.overflow = 'hidden';
    viewerSlider.style.position = 'relative';
    const getSlides = () => Array.from(
      viewerSlider.querySelectorAll('.product__media-item:not(.hidden)')
    );
    let currentIndex = 0;
    let startX = 0;
    let startY = 0;
    let isDragging = false;
    let animating = false;
    let lastMoveX = 0;
    let lastMoveTime = 0;
    let touchStartTime = 0;
    let releaseVelocity = 0;
    let peakDeltaX = 0;
    let currentDeltaX = 0;
    // KALAYLA: נועל את כיוון התנועה (אופקי/אנכי) כדי להבחין בין swipe לגלילת דף
    let gestureDirection = null;
    const sectionId = this.dataset.section;
    const galleryViewer = document.getElementById(`GalleryViewer-${sectionId}`);
    // KALAYLA: כלל הלופ המקורי -
    // כיוון "קדימה" (previous button, index+1) תמיד עובד, גם עוטף מהאחרונה לראשונה - וזה מה שמפעיל hasLooped
    // כיוון "אחורה" (next button, index-1) - מהתמונה הראשונה, קפיצה לאחרונה מותרת רק אחרי שכבר הושלם לופ מלא קדימה
    let hasLooped = false;
    let everMoved = false;
    const applyArrowStates = () => {
      if (!galleryViewer) return;
      galleryViewer.querySelectorAll('[name="previous"]').forEach(btn => {
        // "previous" = קדימה, תמיד פעיל וגלוי
        if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
        btn.style.display = '';
      });
      galleryViewer.querySelectorAll('[name="next"]').forEach(btn => {
        // "next" = אחורה, חסום ומוסתר עד שהושלם לופ מלא קדימה
        const shouldBlock = (currentIndex === 0 && !hasLooped);
        const isDisabled = btn.hasAttribute('disabled');
        if (shouldBlock && !isDisabled) {
          btn.setAttribute('disabled', 'disabled');
        } else if (!shouldBlock && isDisabled) {
          btn.removeAttribute('disabled');
        }
        btn.style.display = shouldBlock ? 'none' : '';
      });
    };
    const updateArrows = (index, slidesCount) => {
      if (index !== 0) everMoved = true;
      applyArrowStates();
    };
    // KALAYLA: "שומר" - קוד מקורי של Shrine מנסה מדי פעם לגעת ב-disabled לפי מיקום גלילה
    // (לא רלוונטי במצב fade) - זה מחזיר תמיד את המצב הנכון שלנו (לא בהכרח "פעיל", אלא המצב שאנחנו רוצים)
    if (galleryViewer) {
      galleryViewer.querySelectorAll('[name="previous"], [name="next"]').forEach(btn => {
        const arrowGuard = new MutationObserver(() => {
          applyArrowStates();
        });
        arrowGuard.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      });
    }
    const syncThumbnailScroll = (index) => {
      if (!this.elements.thumbnails) return;
      const thumbItems = Array.from(
        this.elements.thumbnails.querySelectorAll('.thumbnail-list__item:not(.hidden)')
      );
      if (!thumbItems.length) return;
      const total = thumbItems.length;
      const visibleCount = 5;
      const deadZoneStart = 0;
      const deadZoneEnd = total - 3;
      let targetIndex = 0;
      if (index <= deadZoneStart) {
        targetIndex = 0;
      } else if (index >= deadZoneEnd) {
        targetIndex = total - visibleCount + 2;
      } else {
        targetIndex = index - deadZoneStart;
      }
      targetIndex = Math.max(0, targetIndex);
      
      if (thumbItems[targetIndex]) {
        thumbItems[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };
    const setOpacity = (slides, activeIdx, progress, direction) => {
      const total = slides.length;
      const nextIdx = direction > 0
        ? (activeIdx + 1) % total
        : (activeIdx - 1 + total) % total;
      slides.forEach((s, i) => {
        if (i === activeIdx) {
          s.style.opacity = String(1 - progress);
        } else if (i === nextIdx) {
          s.style.opacity = String(progress);
        } else {
          s.style.opacity = '0';
        }
      });
    };
    const showSlide = (index) => {
      animating = true;
      observer.disconnect();
      const slides = getSlides();
      const fadeDuration = releaseVelocity > 0.1 ? 0.12 : 0.45;
      slides.forEach(s => {
        s.style.transition = `opacity ${fadeDuration}s ease`;
        s.style.transform = 'translateX(0)';
        s.classList.remove('is-active');
        void s.offsetHeight;
      });
      if (slides[index]) {
        slides[index].style.opacity = '1';
        slides[index].classList.add('is-active');
      }
      slides.forEach((s, i) => {
        if (i !== index) s.style.opacity = '0';
      });
      currentIndex = index;
      updateArrows(index, slides.length);
      setTimeout(() => {
        animating = false;
        slides.forEach(s => s.style.transition = 'none');
        observer.observe(viewerSlider, {
          childList: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }, (fadeDuration * 1000) + 50);
      const thumbnail = this.elements.thumbnails?.querySelector(
        `[data-target="${slides[index]?.dataset.mediaId}"]`
      );
      if (thumbnail) this.setActiveThumbnail(thumbnail);
      syncThumbnailScroll(index);
    };
    const syncFromActiveSlide = () => {
      const slides = getSlides();
      const activeSlide = slides.find(s => s.classList.contains('is-active'));
      const newIndex = activeSlide ? slides.indexOf(activeSlide) : 0;
      slides.forEach((s, i) => {
        s.style.transition = 'none';
        s.style.opacity = i === newIndex ? '1' : '0';
      });
      currentIndex = newIndex;
      updateArrows(newIndex, slides.length);
      syncThumbnailScroll(newIndex);
    };
    const observer = new MutationObserver(() => {
      if (isDragging) return;
      syncFromActiveSlide();
    });
    observer.observe(viewerSlider, {
      childList: true,
      subtree: true,
      attributeFilter: ['class']
    });
    const snapBack = () => {
      const slides = getSlides();
      slides.forEach(s => {
        s.style.transition = 'opacity 0.18s ease';
        void s.offsetHeight;
      });
      slides.forEach((s, i) => {
        s.style.opacity = i === currentIndex ? '1' : '0';
      });
      setTimeout(() => {
        slides.forEach(s => s.style.transition = 'none');
      }, 200);
    };
    const initSlides = getSlides();
    initSlides.forEach((s, i) => {
      s.style.transition = 'none';
      s.style.opacity = i === 0 ? '1' : '0';
      s.style.transform = 'translateX(0)';
      if (i === 0) s.classList.add('is-active');
    });
    updateArrows(0, initSlides.length);
    if (this.elements.thumbnails) {
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
        item.querySelector('button')?.addEventListener('click', () => {
          const mediaId = item.dataset.target;
          const slides = getSlides();
          const targetIndex = slides.findIndex(s => s.dataset.mediaId === mediaId);
          if (targetIndex !== -1 && targetIndex !== currentIndex) {
            showSlide(targetIndex);
          }
        });
      });
    }
    viewerSlider.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) {
        isDragging = false;
        return;
      }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      lastMoveX = startX;
      lastMoveTime = Date.now();
      touchStartTime = Date.now();
      releaseVelocity = 0;
      peakDeltaX = 0;
      currentDeltaX = 0;
      isDragging = true;
      animating = false;
      gestureDirection = null;
      const slides = getSlides();
      slides.forEach(s => s.style.transition = 'none');
    }, { passive: true });
    viewerSlider.addEventListener('touchmove', (e) => {
      if (e.touches.length > 1) {
        isDragging = false;
        const slides = getSlides();
        slides.forEach((s, i) => s.style.opacity = i === currentIndex ? '1' : '0');
        return;
      }
      if (!isDragging) return;
      const now = Date.now();
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const timeDelta = Math.max(1, now - lastMoveTime);
      releaseVelocity = Math.abs(currentX - lastMoveX) / timeDelta;
      lastMoveX = currentX;
      lastMoveTime = now;
      currentDeltaX = currentX - startX;
      const deltaY = currentY - startY;
      const absXNow = Math.abs(currentDeltaX);
      const absYNow = Math.abs(deltaY);
      if (gestureDirection === null) {
        if (absXNow < 8 && absYNow < 8) {
          return;
        }
        const angleFromHorizontal = Math.atan2(absYNow, absXNow) * 180 / Math.PI;
        gestureDirection = angleFromHorizontal > 65 ? 'vertical' : 'horizontal';
      }
      if (gestureDirection === 'vertical') {
        return;
      }
      if (e.cancelable) {
        e.preventDefault();
      }
      if (Math.abs(currentDeltaX) > Math.abs(peakDeltaX)) {
        peakDeltaX = currentDeltaX;
      }
      const slides = getSlides();
      const direction = currentDeltaX > 0 ? 1 : -1;
      if (currentIndex === 0 && direction === -1 && !hasLooped) {
        // KALAYLA: אסור עדיין לגלוש אחורה מהראשונה לפני שהושלם לופ מלא - אין fade preview בכיוון הזה
        slides.forEach((s, i) => s.style.opacity = i === 0 ? '1' : '0');
        return;
      }
      const progress = Math.min(1, Math.max(0, Math.abs(currentDeltaX) / (viewerSlider.clientWidth * 0.45)));
      setOpacity(slides, currentIndex, progress, direction);
    }, { passive: false });
    viewerSlider.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      if (gestureDirection === 'vertical') {
        gestureDirection = null;
        return;
      }
      gestureDirection = null;
      const finalDeltaX = e.changedTouches[0].clientX - startX;
      const finalDistance = Math.abs(finalDeltaX) / viewerSlider.clientWidth;
      const peakDistance = Math.abs(peakDeltaX) / viewerSlider.clientWidth;
      const slides = getSlides();
      const totalTime = Math.max(1, Date.now() - touchStartTime);
      const overallVelocity = Math.abs(finalDeltaX) / totalTime;
      const isFastSwipe = releaseVelocity > 0.04 || overallVelocity > 0.04;
      let shouldAdvance = false;
      let goingForward = finalDeltaX > 0;
      const directionReversed = peakDeltaX !== 0 && (
        (peakDeltaX > 0 && finalDeltaX < 0) || 
        (peakDeltaX < 0 && finalDeltaX > 0) ||
        (Math.abs(finalDeltaX) < Math.abs(peakDeltaX) * 0.5)
      );
      if (directionReversed) {
        shouldAdvance = false;
      } else if (isFastSwipe) {
        shouldAdvance = true;
      } else {
        shouldAdvance = finalDistance >= 0.2;
        goingForward = peakDeltaX > 0;
      }
      if (shouldAdvance) {
        if (goingForward) {
          const nextIndex = (currentIndex + 1) % slides.length;
          if (currentIndex === slides.length - 1) {
            // KALAYLA: השלמת לופ מלא קדימה (מהאחרונה חזרה לראשונה) - מעכשיו מותר גם אחורה מהראשונה לאחרונה
            hasLooped = true;
          }
          showSlide(nextIndex);
          return;
        } else {
          if (currentIndex === 0 && !hasLooped) {
            // KALAYLA: אסור לקפוץ מהראשונה לאחרונה לפני שהושלם לופ מלא קדימה - נשארים במקום
            snapBack();
            return;
          }
          showSlide((currentIndex - 1 + slides.length) % slides.length);
          return;
        }
      }
      snapBack();
    }, { passive: true });
    viewerSlider.addEventListener('touchcancel', () => {
      if (!isDragging) return;
      isDragging = false;
      gestureDirection = null;
      snapBack();
    }, { passive: true });
    if (galleryViewer) {
      galleryViewer.querySelectorAll('[name="previous"]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const slides = getSlides();
          if (currentIndex === slides.length - 1) {
            hasLooped = true;
          }
          showSlide((currentIndex + 1) % slides.length);
        });
      });
      galleryViewer.querySelectorAll('[name="next"]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex === 0 && !hasLooped) return;
          const slides = getSlides();
          showSlide((currentIndex - 1 + slides.length) % slides.length);
        });
      });
    }
  };
  tryInit();
}
  });
}